export default __webpack_public_path__ + "static/media/coru-logo-gray-400.7c7dedd6.svg";